import React, { useCallback, useContext, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import SvgCheckOk from '../../../icons/CheckOK'
import styles from '../../../styles'
import { formatJourSemaine } from '../../../utils/formatter/formatDate'
import { makeStyles } from 'tss-react/mui'
import { Grid, useTheme } from '@mui/material'
import { languages } from '../../../components/langContext/enum/languagesEnum'
import { buttonSize } from '../../../components/button/enums/buttonEnum'
import Button from '../../../components/button/Button'
import { SelectionPaneContext } from '../../../components/selectionPane/components/SelectionPaneContext'
import links from '../../../enums/linksEnum'
import { useNavigate } from 'react-router'
import { DEFAULT_OFFER_FILTERS } from '../../rechercheOffre/utils/rechercheOffreConstants'

const useStyles = makeStyles()(
	(theme) => ({
		popInContainerStyle: {
			padding: '31px 29px 10px 20px'
		},
		pictoContainer: {
			marginRight: 80
		},
		titre: {
			...styles(theme).title2,
			marginTop: 10
		},
		date: {
			...styles(theme).text0,
			fontSize: 23,
			lineHeight: '33px'
		},
		texte: {
			...styles(theme).text1,
			fontSize: 16,
			lineHeight: '23px',
			marginBottom: 27
		},
		buttonStyle: {
			borderRadius: 40,
			maxWidth: 198,
			marginTop: 24
		}
	})
)

interface AcceptingProps {
	date: string
}

const PopinConfirmationRDV: React.FC<AcceptingProps> = ({ date }) => {
	const { classes } = useStyles()
	const theme = useTheme()
	const navigate = useNavigate()
	const dateFormatee = useMemo(() => formatJourSemaine(date, languages.FR), [date])
	const { resetSelection } = useContext(SelectionPaneContext)

	const reset = useCallback(() => {
		resetSelection()
		navigate({ pathname: links.RECHERCHE_OFFRE, search: DEFAULT_OFFER_FILTERS })
	}, [resetSelection, navigate])

	return (
		<Grid container item>
			<Grid container item className={classes.popInContainerStyle}>
				<Grid container item spacing="70px">
					<Grid item>
						<SvgCheckOk color={theme.palette.primary.main} />
					</Grid>
					<Grid container item xs>
						{/* Titre de la popin */}
						<Grid container item xs={12} className={classes.titre}>
							<FormattedMessage
								id="visites.popin.confirmationRDV.titre"
								defaultMessage="Votre demande de visite a bien été confirmée"
								description="Titre de la popin de confirmation de RDV"
							/>
						</Grid>
						{/* Résumé de la date de rdv */}
						<Grid container item xs={12} className={classes.date}>
							{dateFormatee}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			{/* Bloc des boutons */}
			<Grid container item xs={12}>
				<Button
					background="backgroundAccessibility"
					color="colorWhite"
					textStyle="text4"
					size={buttonSize.small}
					onClick={reset}
					buttonStyle={classes.buttonStyle}
					fullWidth
				>
					<FormattedMessage
						id="selectionPanel.btn"
						defaultMessage="Nouvelle recherche"
						description="Bouton pour faire une nouvelle recherche"
					/>
				</Button>
			</Grid>
		</Grid>
	)
}

export default PopinConfirmationRDV
